import React from 'react';

const SvgMoreVert = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M16 12c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-6 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z" />
  </svg>
);

export default SvgMoreVert;
